import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { API_COURSE_COUNT } from "../../config/Api";

function CourseCount(props) {
  const [courseCount, setCourseCount] = useState(0);

  let center_ref = "";
  let fin_year = props.getFinancialYear();

  if (
    localStorage.getItem("user") !== null &&
    localStorage.getItem("center") !== null
  ) {
    const user = JSON.parse(localStorage.getItem("user"));
    const center = JSON.parse(localStorage.getItem("center"));

    if (user.role.role_name == "CENTER ADMIN") {
      center_ref = "/" + center.ref;
    }
  }

  useEffect(() => {
    fetchCourseCount();
    const interval = setInterval(() => {
      fetchCourseCount();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchCourseCount = () => {
    props.callRequest("GET", API_COURSE_COUNT + '/' + fin_year + center_ref, true, null).then((res) => {
      setCourseCount(res.data.course_count);
    }).catch((e) => {
      console.log(e);
    });
  };

  return (
    <>
      <Card>
        <Card.Body>
          <div className="row d-flex align-items-center">
            <div className="col-4">
              <i className="las la-laptop-code card-icon-lg"></i>
            </div>
            <div className="col-8">
              <Link to="/courses">
                <h4 className="text-muted fw-bold m-0">Courses</h4>
              </Link>

              <h2 className="fw-bolder m-0">{courseCount}</h2>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default CourseCount;
